var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "channel-manager-settings text-left p-4" },
    [
      _c(
        "b-row",
        { staticClass: "no-gutters" },
        [
          _c(
            "b-col",
            { staticClass: "position-relative", attrs: { sm: "12" } },
            [
              _c("h3", { staticClass: "text-center" }, [
                _vm._v("Channex Integration"),
              ]),
              _c(
                "b-button",
                {
                  staticClass: "btn-sync",
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      _vm.showSyncModal = true
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fi-refresh" }),
                  _c("span", { staticClass: "ml-1" }, [_vm._v("Sync")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.unitTypes, function (unitType) {
        return _c(
          "b-row",
          { key: unitType.id, staticClass: "mt-3" },
          [
            _c("b-col", { attrs: { sm: "12" } }, [
              _c("p", { staticClass: "font-weight-bold mb-0" }, [
                _vm._v(
                  _vm._s(unitType.unit_type_name) +
                    " (" +
                    _vm._s(unitType.unit_type_description) +
                    ")"
                ),
              ]),
              _c("hr", { staticClass: "mt-0" }),
            ]),
            _vm._l(unitType.unit, function (unit) {
              return _c(
                "b-col",
                { key: unit.id, attrs: { sm: "12" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center mb-2" },
                    [
                      _c("b-col", { attrs: { sm: "6" } }, [
                        _vm._v(
                          _vm._s(unit.unit_name) +
                            " (" +
                            _vm._s(unit.unit_description) +
                            ", occ: " +
                            _vm._s(unit.default_occupancy) +
                            ")"
                        ),
                      ]),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { sm: "6" },
                        },
                        [
                          _c("toggle-button", {
                            staticClass: "active-toggle mr-5",
                            staticStyle: { "font-size": "16px" },
                            attrs: {
                              value: !!unit.channex_connected,
                              labels: { checked: "ON", unchecked: "OFF" },
                              width: 80,
                              height: 33,
                              sync: true,
                              color: "#82C7EB",
                            },
                            on: { change: (v) => _vm.onToggleConnect(unit, v) },
                          }),
                          _c("b-form-select", {
                            staticClass: "form-control",
                            attrs: {
                              "value-field": "id",
                              "text-field": "title",
                              options: _vm.channexRoomTypeOptions,
                              disabled: !unit.channex_connected,
                            },
                            on: {
                              change: (e) => _vm.onSelectRoomType(unit, e),
                            },
                            model: {
                              value: unit.channex_room_id,
                              callback: function ($$v) {
                                _vm.$set(unit, "channex_room_id", $$v)
                              },
                              expression: "unit.channex_room_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
          ],
          2
        )
      }),
      _c("sync-main-modal", {
        on: {
          "import-bookings": _vm.onImportBookings,
          "sync-units": _vm.onSendUnits,
          "sync-rates": function ($event) {
            _vm.showSyncRatesModal = true
          },
          "sync-avr": function ($event) {
            _vm.showSyncAvrModal = true
          },
        },
        model: {
          value: _vm.showSyncModal,
          callback: function ($$v) {
            _vm.showSyncModal = $$v
          },
          expression: "showSyncModal",
        },
      }),
      _c("sync-rates-modal", {
        on: { sync: _vm.onSyncRates },
        model: {
          value: _vm.showSyncRatesModal,
          callback: function ($$v) {
            _vm.showSyncRatesModal = $$v
          },
          expression: "showSyncRatesModal",
        },
      }),
      _c("sync-availability-modal", {
        on: { sync: _vm.onSyncAvailability },
        model: {
          value: _vm.showSyncAvrModal,
          callback: function ($$v) {
            _vm.showSyncAvrModal = $$v
          },
          expression: "showSyncAvrModal",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }